'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useEffect, useState } from 'react';
import { useDebounce, useUpdateEffect } from 'usehooks-ts';
import SearchInput from '../../search-input';
type TableFilterProps = {
  children: React.ReactNode;
  initialValue?: string;
  onChangeText?: (text: string) => void;
  placeholder: string;
  isPrivate?: boolean;
};
const TableFilter = t0 => {
  const $ = _c(16);
  const {
    children,
    onChangeText,
    initialValue: t1,
    placeholder,
    isPrivate
  } = t0;
  const initialValue = t1 === undefined ? "" : t1;
  const [search, setSearch] = useState(initialValue);
  let t2;
  let t3;
  if ($[0] !== initialValue) {
    t2 = () => {
      setSearch(initialValue);
    };
    t3 = [initialValue];
    $[0] = initialValue;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const debouncedSearch = useDebounce(search, 300);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = nextValue => {
      setSearch(nextValue);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleChangeText = t4;
  let t5;
  if ($[4] !== debouncedSearch || $[5] !== onChangeText) {
    t5 = () => {
      onChangeText?.(debouncedSearch);
    };
    $[4] = debouncedSearch;
    $[5] = onChangeText;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== debouncedSearch) {
    t6 = [debouncedSearch];
    $[7] = debouncedSearch;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  useUpdateEffect(t5, t6);
  const t7 = isPrivate ? "mask" : undefined;
  let t8;
  if ($[9] !== placeholder || $[10] !== search || $[11] !== t7) {
    t8 = <SearchInput autoCapitalize="off" autoComplete="off" autoCorrect="off" onChangeText={handleChangeText} placeholder={placeholder} size="compact" shape="pill" value={search} width="100%" containerClassName="w-full md:w-[330px]" data-dd-privacy={t7} />;
    $[9] = placeholder;
    $[10] = search;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== children || $[14] !== t8) {
    t9 = <div className="flex flex-wrap gap-3 [&>div]:max-w-full">{t8}{children}</div>;
    $[13] = children;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default TableFilter;